import React from 'react';
import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Button
} from '@one-thd/sui-atomic-components';
import {
  Text,
  Images
} from './drawer-components';
import { useFuelType } from './FuelTypeProvider';
import {
  ALERT_AND_HEADER,
  ELECTRIC,
  GAS,
  DUAL_FUEL,
  TIP,
  WASHER_VS_DRYER,
  INDUCTION,
  GAS_VALVE_CLARITY,
  MODEL_INFORMATION,
  NEW_PARTS,
  ELECTRIC_OUTLET,
  GAS_LINE,
  ADDITIONAL_GUIDANCE,
  GAS_VS_ELECTRIC,
  DRYER_ELECTRIC_IMAGES,
  RANGE_ELECTRIC_IMAGES,
  GAS_IMAGES
} from '../constants';

export const FuelTypeDrawer = () => {
  const {
    categories,
    isDryer,
    isRange,
    isEither,
    hasDualFuel,
    entryType,
    position,
    drawerOpen,
    setDrawerOpen
  } = useFuelType();

  const onDrawerClose = () => setDrawerOpen(false);

  const buildCategoryLabel = (subsequentText) => {
    const category = categories[0];
    const isPlural = category.charAt(category.length - 1) === 's';
    return ` ${category}${isPlural ? '' : 's'}${subsequentText ? ` ${subsequentText}` : ''}`;
  };

  return (
    <Drawer
      data-testid="appliance-fuel-type-drawer"
      DrawerRootProps={{
        id: 'appliance-fuel-type-drawer'
      }}
      position={position}
      open={drawerOpen}
      onClose={onDrawerClose}
    >
      <DrawerHeader
        data-testid="appliance-fuel-type-drawer-header"
        title={ALERT_AND_HEADER}
        onClose={onDrawerClose}
        onBack={entryType === 'BASIC' ? onDrawerClose : null}
      />
      <DrawerBody data-testid="appliance-fuel-type-drawer-body">
        <div
          data-testid="appliance-fuel-type-body"
          className="sui-mt-2"
        >
          {hasDualFuel && (
            <Text
              normalText={DUAL_FUEL}
              wrapperClasses="sui-mb-4"
            />
          )}
          {isDryer && (
            <Text
              normalText={WASHER_VS_DRYER}
              wrapperClasses="sui-mb-4"
            />
          )}
          {isEither && (
            <Text
              boldText={ELECTRIC}
              normalText={buildCategoryLabel(ELECTRIC_OUTLET)}
              wrapperClasses="sui-mb-4"
            />
          )}
          {isRange && (
            <Text
              normalText={INDUCTION}
              wrapperClasses="sui-mb-6"
            />
          )}
          {isDryer && (
            <Images
              images={DRYER_ELECTRIC_IMAGES}
              separator="or"
              wrapperClasses="sui-gap-8 sui-mb-6 sui-max-w-[63%]"
              imageClasses="sui-min-w-24"
              separatorClasses="sui-text-3xl"
            />
          )}
          {isRange && (
            <Images
              images={RANGE_ELECTRIC_IMAGES}
              separator="or"
              wrapperClasses="sui-gap-8 sui-mb-6 sui-max-w-[63%]"
              imageClasses="sui-min-w-24"
              separatorClasses="sui-text-3xl"
            />
          )}
          {isEither && (
            <Text
              boldText={GAS}
              normalText={buildCategoryLabel(GAS_LINE)}
              wrapperClasses="sui-mb-6"
            />
          )}
          {isEither && (
            <Images
              images={GAS_IMAGES}
              separator="+"
              wrapperClasses="sui-gap-8 sui-mb-6 sui-max-w-[75%]"
              imageClasses="sui-min-w-24"
              separatorClasses="sui-text-6xl"
            />
          )}
          {isEither && (
            <Text
              normalText={GAS_VALVE_CLARITY}
              wrapperClasses="sui-mb-6"
            />
          )}
          {isEither && (
            <Text
              boldText={TIP}
              normalText={MODEL_INFORMATION}
              hasBorder
              wrapperClasses="sui-mb-4"
            />
          )}
          {isEither && (
            <Text
              normalText={NEW_PARTS}
              wrapperClasses="sui-mb-4"
            />
          )}
          {isRange && (
            <Text
              normalText={ADDITIONAL_GUIDANCE}
              linkText={GAS_VS_ELECTRIC.text}
              url={GAS_VS_ELECTRIC.url}
            />
          )}
        </div>
      </DrawerBody>
      <DrawerFooter data-testid="appliance-fuel-type-drawer-footer">
        <Button
          data-testid="appliance-fuel-type-close-button"
          onClick={onDrawerClose}
          fullWidth
        >
          Close
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};
